<template>
    <div class="data-container" ref="dataContainer">
        <div class="left">
            <div
                class="left-item"
                :class="{ select: filter.feeType === '' }"
                @click="selectFeeType('')"
            >
                <div class="text">结余</div>
                <div class="price">{{ leftAmount | currency }}</div>
            </div>
            <div v-if="loading2" class="loading">
                <Spin size="large" fix></Spin>
            </div>
            <div
                v-else
                class="left-item"
                :class="{ select: filter.feeType === item.feeType }"
                v-for="(item, index) in leftList"
                :key="index"
                @click="selectFeeType(item.feeType)"
            >
                <div class="text">{{ item.feeTypeText }}</div>
                <div
                    class="price"
                    :style="{
                        color: item.flowType === '1' ? '#FF3739' : '#70B603',
                    }"
                >
                    {{ item.amount | currency }}
                </div>
            </div>
        </div>
        <div class="right">
            <Table
                :columns="columns"
                :data="page.list"
                :loading="loading"
                :height="mtHeight"
            >
                <template v-slot:amount="{ row }">
                    <tag-status
                        :text="row.amount"
                        :color="row.flowType === '1' ? '#FF3739' : '#70B603'"
                    />
                </template>
            </Table>
            <!-- 底部分页 -->
            <table-pager
                :total.sync="page.total"
                :pageSize.sync="filter.pageSize"
                :pageNo.sync="filter.pageNo"
                @change="fetch"
            ></table-pager>
        </div>
    </div>
</template>

<script>
import { mapCache } from "@/plugins/vux-data-cache";
import { debounce, ymdL, currency } from "_u/helper";
import Dict from "_u/dict";

import TagStatus from "_vc/tag-status";

import { financesFlowSumList, financeFlowDetailList } from "@/api/finance";

export default {
    components: { TagStatus },
    data() {
        return {
            loading: false,
            loading2: false,
            leftList: [],
            leftAmount: 0,
            page: {
                total: 0,
                list: [],
            },
            mtHeight: 300,
            dict: {
                feeType: Dict.NULL,
            },
        };
    },
    computed: {
        ...mapCache({
            filter: "financeAnalysisIndex",
        }),
        columns() {
            return [
                {
                    key: "clinchTime",
                    title: "到账时间",
                    align: "left",
                    minWidth: 150,
                    tooltip: true,
                },
                {
                    key: "feeTypeText",
                    title: "费用类型",
                    align: "left",
                    minWidth: 100,
                    tooltip: true,
                },
                {
                    key: "houseName",
                    title: "房源名称",
                    align: "left",
                    minWidth: 120,
                    tooltip: true,
                },

                {
                    key: "cusName",
                    title: "客户名称",
                    align: "left",
                    minWidth: 100,
                    tooltip: true,
                },
                {
                    key: "amount",
                    title: "金额",
                    align: "right",
                    minWidth: 120,
                    tooltip: true,
                    slot: "amount",
                },
            ];
        },
    },
    watch: {
        filter: {
            handler() {
                this.search();
            },
            immediate: true,
            deep: true,
        },
    },
    methods: {
        fetch() {
            this.loading = true;
            Promise.all([
                financesFlowSumList({
                    houseId: this.filter.houseId,
                    year: this.filter.year,
                    month: this.filter.month,
                }),
                financeFlowDetailList(this.filter),
                Dict.get(["fee_type"]),
            ])
                .then((args) => {
                    var [left, right, dictGroup] = args;

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name];
                    });

                    this.leftList = this.formateLeftList(left.data.list);
                    this.setPageData(right.data);
                })
                .finally(() => {
                    this.loading = false;
                    this.loading2 = false;
                });
        },
        // 请求节流
        filterChange: debounce(500, function() {
            this.fetch();
        }),
        // 左侧列表格式化
        formateLeftList(list) {
            let newList = [];
            let leftAmount = 0;
            let positive = [],
                negative = [];
            list.forEach((v) => {
                if (v.flowType === "2") {
                    v.amount = "-" + v.amount;
                }
                newList.push({
                    amount: v.amount / 100,
                    feeType: v.feeType,
                    feeTypeText: this.dict.feeType.val(v.feeType),
                    flowType: v.flowType,
                });
                leftAmount += v.amount / 100;
            });
            newList = this.mergeFee(newList);
            positive = newList.filter((v) => v.amount >= 0);
            negative = newList.filter((v) => v.amount < 0);
            positive.sort((a, b) => b.amount - a.amount);
            negative.sort((a, b) => a.amount - b.amount);
            newList = positive.concat(negative);

            this.leftAmount = leftAmount;
            return newList;
        },
        // 合并相同费用类型
        mergeFee(list) {
            const feeTypeObj = {};
            const newList = [];
            list.forEach((v) => {
                if (feeTypeObj[v.feeType] === true) {
                    newList.find(
                        (p) => p.feeType === v.feeType
                    ).amount -= -v.amount;
                } else {
                    newList.push(v);
                    feeTypeObj[v.feeType] = true;
                }
            });
            return newList;
        },
        // 右侧列表数据设置
        setPageData(data) {
            data.page.list.forEach((v) => {
                if (v.flowType === "2") {
                    v.amount = "-" + v.amount;
                }
                v.clinchTime = ymdL(v.clinchTime);
                v.amount = currency(v.amount / 100);
                v.feeTypeText = this.dict.feeType.val(v.feeType);
            });
            this.page.list = data.page.list;
            this.page.total = parseInt(data.page.totalCount);
        },
        search() {
            this.filter.pageNo = 1;
            this.filterChange();
        },
        // 费用类型更改
        selectFeeType(feeType) {
            this.filter.feeType = feeType;
        },
    },
    created() {
        this.loading = true;
        this.loading2 = true;
        this.filterChange();
    },
    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight = this.$refs.dataContainer.clientHeight - 40;
        });
    },
};
</script>

<style lang="less" scoped>
.data-container {
    height: 100%;
    display: flex;
    .left {
        font-size: 14px;
        min-width: 300px;
        border: 1px solid #dddddd;
        &-item {
            height: 40px;
            display: flex;
            align-items: center;
            padding: 0px 15px;
            .text {
                width: 120px;
                padding-left: 20px;
            }
            .price {
                flex-grow: 1;
                text-align: right;
            }
        }
    }
    .right {
        flex-grow: 1;
        margin-left: 20px;
    }
    .select {
        background-color: #f7f7f7;
        .text {
            width: 120px;
            padding-left: 10px;
            position: relative;
        }
        .text::before {
            position: absolute;
            top: 50%;
            left: 0px;
            width: 6px;
            height: 18px;
            border-radius: 2px;
            background-color: rgb(44, 141, 240);
            transform: translateY(-50%);
            content: "";
        }
    }
    .loading {
        position: relative;
        top: 50%;
    }
}
</style>
